import { ConfigProvider, Typography, Flex, Card } from 'antd';
import { getFormattedDateFromTimestamp } from '../../../utilities/commonFunctions';
import Icon from '@ant-design/icons';
import { ReactComponent as Message } from '../../../assets/icons/message.svg';

const { Title, Text } = Typography;

const EmptyBroadcast = () => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginTop: '16px',
            titleMarginBottom: '0px',
          },
        },
      }}
    >
      <Card
        variant="borderless"
        style={{ height: '100%' }}
        className="broadcast-status-empty-card"
      >
        <Title level={4} style={{ paddingTop: '16px' }}>
          Broadcast Status
        </Title>
        <Text className="broadcast-status-date">
          {getFormattedDateFromTimestamp(Date.now())}
        </Text>
        <Flex
          vertical
          align="center"
          justify="center"
          className="broadcast-status-empty-content"
        >
          <Icon component={Message} className="message-icon" />
          <Text strong className="emptybroadcast-text">
            No broadcast messages have been sent yet
          </Text>
          <Text className="emptybroadcast-subtext">
            Your daily message sent status will be shown here.
          </Text>
        </Flex>
      </Card>
    </ConfigProvider>
  );
};

export default EmptyBroadcast;
